import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=53e94d6c"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e94d6c')) {
      api.createRecord('53e94d6c', component.options)
    } else {
      api.reload('53e94d6c', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=53e94d6c", function () {
      api.rerender('53e94d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/Main.vue"
export default component.exports